import styled from '../styled';

const Image = styled.img``;

export default Image;
